import React, { FC } from 'react';
import { TypeMediaCollectionSupportingContentFields } from '@/core/generated-types';
import {
  Badge,
  HeaderText,
  LuvImage,
  MediaCollectionSong,
  MediaCollectionSongPreview,
  PdfDownload,
  RichText,
} from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';
import {
  RefetchTokenSetFn,
  RetrieveTokenSetFn,
} from '@/lib/api/playbackService/hooks/useTokenSetVault';
import { Document } from '@contentful/rich-text-types';

export interface TypeCourseAccessItemWithCourseData
  extends TypeMediaCollectionSupportingContentFields {
  retrieveSongAssetFromVault?: RetrieveTokenSetFn | undefined;
  fetchTokenSetForSongAsset?: RefetchTokenSetFn | undefined;
}

const MediaCollectionSupportingContent: FC<
  TypeCourseAccessItemWithCourseData
> = ({
  details,
  songFull,
  songPreview,
  digitalPlayGuide,
  badge,
  retrieveSongAssetFromVault,
  fetchTokenSetForSongAsset,
}) => {
  const { image, textBody, textHeading } = details.fields;

  return (
    <div
      className="relative sm:mx-4 lg:max-w-[360px]"
      data-testid="media-collection-supporting-content-item"
    >
      {badge && (
        <div className="absolute left-0 top-0 ml-4 mt-6">
          <Badge {...badge.fields} />
        </div>
      )}
      <LuvImage
        imageData={image}
        width={360}
        height={360}
        className="w-full lg:h-[360x] lg:w-[360px] lg:object-cover"
      />
      <HeaderText
        size={HeaderSize.H3}
        text={textHeading}
        align="left"
        classes="mt-4 mb-2"
      />
      <div className="text-left">
        {textBody && <RichText content={textBody as Document} />}
      </div>
      {songPreview && <MediaCollectionSongPreview {...songPreview.fields} />}
      {songFull && retrieveSongAssetFromVault && fetchTokenSetForSongAsset && (
        <MediaCollectionSong
          {...songFull.fields}
          retrieveSongAssetFromVault={retrieveSongAssetFromVault}
          fetchTokenSetForSongAsset={fetchTokenSetForSongAsset}
        />
      )}
      {digitalPlayGuide && (
        <PdfDownload
          pdf={digitalPlayGuide.fields}
          classes="flex align-start mt-2"
        />
      )}
    </div>
  );
};

export default React.memo(MediaCollectionSupportingContent);
